import React from "react";
import coughIcon from "../../Assets/Images/coughIcon.svg";

export default function CoughCard({ totalCount, filterBy, data }) {
  const totalCoughcoUnt = () => {
    let totalCount = 0;
    for (let i = 0; i < data.length; i++) {
      totalCount += data[i].count;
    }
    return totalCount;
  };

  return (
    <div className="dash-cards w-100 h-100 d-flex flex-column p-4">
      <div className="ms-2 my-auto">
        <p className="fs-24 fw-600 Roboto text-grey-black mb-4">
          Cough Summary
        </p>
        <p className="fs-20 fw-700 Roboto text-primry mb-4">
          Coughed {totalCoughcoUnt()} Times
        </p>
        <img
          src={coughIcon}
          alt="inhaler"
          width={80}
          height={80}
          className="my-4"
        />
      </div>
    </div>
  );
}
